/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reflectionIndex.vue?vue&type=template&id=019921f4&scoped=true"
import script from "./reflectionIndex.vue?vue&type=script&lang=js"
export * from "./reflectionIndex.vue?vue&type=script&lang=js"
import style0 from "./reflectionIndex.vue?vue&type=style&index=0&id=019921f4&prod&lang=scss"
import style1 from "./reflectionIndex.vue?vue&type=style&index=1&id=019921f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019921f4",
  null
  
)

export default component.exports